import React from "react";
import { Flex } from "@chakra-ui/react";
import { Deduction } from "views/admin/partnerDetail/types";
import { deductionsColumnsDataComplex } from "views/admin/partnerDetail/variables/deductionsColumnsData";
import DeductionsTable from "./DeductionsTable";

interface DeductionsViewProps {
  deductions: Deduction[];
  partnerId: number;
  setPartnerData: any;
}

const DeductionsView = (props: DeductionsViewProps) => {
  const { deductions, partnerId, setPartnerData } = props;

  let deductionsTableColumns = deductionsColumnsDataComplex;

  return (
    <Flex flexDir={"column"} mt={8}>
      <DeductionsTable
        isLoading={false}
        columnsData={deductionsTableColumns}
        tableData={
          deductions?.sort(
            (a, b) =>
              new Date(b.redeemedAt).getTime() -
              new Date(a.redeemedAt).getTime()
          ) ?? []
        }
        partnerId={partnerId}
        setPartnerData={setPartnerData}
      />
    </Flex>
  );
};

export default DeductionsView;
